import { Result } from 'antd';
import { MdErrorOutline } from 'react-icons/md';

interface LoaderErrorProps {
    message?: string;
}

const LoaderError: React.FC<LoaderErrorProps> = ({
    message = "Le chargement de la page a échoué"
}) => {
    return (
        <div className="flex items-center justify-center min-h-screen">
            <Result
                icon={<MdErrorOutline className="text-4xl text-red-500" />}
                status="error"
                title={message}
                subTitle="Veuillez vérifier votre connexion internet et réessayer"
            />
        </div>
    );
};

export default LoaderError; 